import { render, staticRenderFns } from "./BuyListView.vue?vue&type=template&id=2bd16e6e&scoped=true&"
import script from "./BuyListView.vue?vue&type=script&lang=js&"
export * from "./BuyListView.vue?vue&type=script&lang=js&"
import style0 from "./BuyListView.vue?vue&type=style&index=0&id=2bd16e6e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bd16e6e",
  null
  
)

export default component.exports